/**
 * Given the depots indexed by coordinates and the location the pin was moved to,
 * work out which depot the field should be connected to.
 *
 * Multiple depots can share the same coordinates, so if the currently connected
 * depot still sits at the location we keep it (a location update must not silently
 * flip the connection to another depot at the same spot). Otherwise we connect to
 * the first depot found there, or clear the connection when the spot has no depot.
 *
 * WHICH depot is picked when selecting from the dropdown is owned by the dropdown
 * itself - this helper is only for user-driven pin moves (drag / adjust address).
 */
export function resolveConnectedDepotId(
  depotsAsMap: Record<string, uui.domain.client.rm.Depot[]>,
  rawLatLngAsString: string,
  connectedPlaceId?: string,
): string | undefined {
  const depots = depotsAsMap[rawLatLngAsString] ?? []

  return depots.some(depot => depot.id === connectedPlaceId) ? connectedPlaceId : depots[0]?.id
}
